





































import { computed, defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "BaseButton",
  components: { BaseSpinner },
  props: {
    fullWidth: { type: Boolean },
    to: { type: Object as () => Location },
    href: { type: String },
    secondary: { type: Boolean },
    gradient: { type: Boolean },
    outline: { type: Boolean },
    outlineSecondary: { type: Boolean },
    outlineGray: { type: Boolean },
    gray: { type: Boolean },
    darkGray: { type: Boolean },
    green: { type: Boolean },
    red: { type: Boolean },
    white: { type: Boolean },
    small: { type: Boolean },
    xSmall: { type: Boolean },
    medium: { type: Boolean },
    round: { type: Boolean },
    disabled: { type: Boolean },
    transparent: { type: Boolean },
    semiTransparent: { type: Boolean },
    semiBold: { type: Boolean },
    textLike: { type: Boolean },
    linkLike: { type: Boolean },
    loading: { type: Boolean },
    target: { type: String },
    spinnerColor: { type: String },
    spinnerSize: { type: String },
  },
  setup(props, { emit }) {
    const onClick = (e: MouseEvent) => {
      if (props.disabled || props.loading) return;
      emit("click", e);
    };
    const totalSpinnerSize = computed(() => {
      if (props.spinnerSize) return props.spinnerSize;
      return props.small ? "20px" : "35px";
    });

    const totalSpinnerColor = computed(() => {
      if (props.spinnerColor) return props.spinnerColor;
      if (props.outlineSecondary) return "var(--palette-secondary)";
      if (props.gray) return "#fff";
      return props.secondary || props.outline ? "var(--palette-negative)" : "var(--palette-bg)";
    });
    return {
      onClick,
      totalSpinnerSize,
      totalSpinnerColor,
    };
  },
});
